import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { PortfolioSection } from './components/PortfolioSection';
import { AboutSection } from './components/AboutSection';
import { WhoWeServeSection } from './components/WhoWeServeSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-sunrise-cream font-body selection:bg-sunrise-orange selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <PortfolioSection data-id="element-5" />
        <AboutSection data-id="element-6" />
        <WhoWeServeSection data-id="element-7" />
        <ContactSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}